/* eslint-disable */
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
    Input,
    ComponentFactoryResolver,
    ViewChild,
    ViewContainerRef,
    AfterViewInit,
    Output,
    EventEmitter,
} from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Field } from "../vforms-model";
import { FieldPreviewComponent } from "../field-preview.component";
import { DragStylingService } from "../drag-styling.service";

@Component({
    selector: "control-preview",
    templateUrl: "./control-preview.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ControlPreviewComponent implements OnInit, OnDestroy, AfterViewInit {
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    @Input()
    field: Field;

    @Input()
    editable = true;

    @ViewChild("content", { read: ViewContainerRef }) contentHost;

    @Output()
    onEdit: EventEmitter<Field> = new EventEmitter<Field>();

    @Output()
    onDelete: EventEmitter<Field> = new EventEmitter<Field>();

    @Output()
    onDuplicate: EventEmitter<Field> = new EventEmitter<Field>();

    @Input()
    draggingField: Field | undefined = undefined;

    constructor(
        private _changeDetector: ChangeDetectorRef,
        private _componentFactoryResolver: ComponentFactoryResolver,
        private _dragStylingService: DragStylingService
    ) {}

    ngOnInit(): void {
        this.field.onChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe((changed) => {
            this._changeDetector.detectChanges();
        });

        this._dragStylingService.onEditorDragging$.pipe(takeUntil(this._unsubscribeAll)).subscribe((field) => {
            this.draggingField = field;
            this._changeDetector.markForCheck();
        });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    ngAfterViewInit() {
        const factory = this._componentFactoryResolver.resolveComponentFactory(this.field.type.previewComponent);
        const componentRef = this.contentHost.createComponent(factory);
        const instance = componentRef.instance as FieldPreviewComponent;
        instance.field = this.field;
        this._changeDetector.markForCheck();
    }

    edit() {
        this.onEdit.emit(this.field);
    }

    delete() {
        this.onDelete.emit(this.field);
    }

    duplicate() {
        this.onDuplicate.emit(this.field);
    }

    dragStarted() {
        this.draggingField = this.field;
        this._dragStylingService.onEditorDragging$.next(this.field);
        this._changeDetector.markForCheck();
    }

    dragEnded() {
        this.draggingField = undefined;
        this._dragStylingService.onEditorDragging$.next(undefined);
        this._changeDetector.markForCheck();
    }
}
